import {appConfig} from '@/config/appConfig';

export function redirectIfRootDomain(): void {
    if (__IS_HYBRID_APP__) {
        return;
    }
    const hostname = window.location.hostname; // e.g., "sub.example.com"
    const parts = hostname.split('.');

    // Handle localhost separately
    if (hostname === 'localhost') return;

    // Only redirect if on the root domain (e.g. desk.ly), not a subdomain (e.g. app.desk.ly)
    if (parts.length <= 2) {
        const {protocol, port, pathname, search, hash} = window.location;
        const portSuffix = port ? `:${port}` : '';
        window.location.replace(
            `${protocol}//app.${hostname}${portSuffix}${pathname}${search}${hash}`
        );
    }
}

const SAFE_HREF_PROTOCOLS = ['http:', 'https:'];

// Blocks javascript:/data: schemes when a user-supplied url is interpolated into an href.
export function safeHref(url: string): string {
    try {
        return SAFE_HREF_PROTOCOLS.includes(new URL(url).protocol) ? url : '#';
    } catch {
        return '#';
    }
}

/**
 * Returns the image url directly if not in hybrid app context.
 * Otherwise returns the full url (including baseUrl) if the image url is relative.
 */
export function getNormalizedImageUrl(imageUrl: string | null | undefined): string | null {
    if (!__IS_HYBRID_APP__) {
        return imageUrl ?? null;
    }

    if (!imageUrl) {
        return null;
    }

    if (imageUrl.trim().startsWith('http')) {
        return imageUrl;
    }

    return `${appConfig.baseUrl}${imageUrl}`;
}
